(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-buybox-discount-message"] && !Shopify.designMode) return;
  try {
    function initBuyboxDiscounts() {
    const cards = document.querySelectorAll('[data-buybox-discount]');
    if (!cards.length) return;

    function updateDiscounts() {
      cards.forEach(function (card) {
        const form = card.closest('form');
        const toggle = (form && form.querySelector('.subscription-toggle-input')) || document.querySelector('.subscription-toggle-input');
        card.hidden = Boolean(toggle && toggle.checked);
        const variantSelect = (form && form.querySelector('.all-variant')) || document.querySelector('.all-variant');
        const option = variantSelect && variantSelect.selectedOptions[0];
        if (!option) return;

        const onetimePrice = Number(option.getAttribute('data-price'));
        const originalPrice = onetimePrice;
        if (!Number.isFinite(originalPrice) || originalPrice <= 0) return;

        const percent = Number(card.dataset.discountPercent) || 0;
        const formattedPrice = window.VastaShop && typeof window.VastaShop.formatMoney === 'function'
          ? window.VastaShop.formatMoney(originalPrice)
          : new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency', currency: card.dataset.currency || 'USD'
            }).format(originalPrice / 100);
        card.querySelector('[data-buybox-original-price]').innerHTML = formattedPrice;
        const percentNode = card.querySelector('[data-buybox-discount-percent]');
        percentNode.textContent = '(-' + percent + '%)';
        percentNode.hidden = percent <= 0;
      });
    }

    if (window.buyboxDiscountUpdate) {
      document.removeEventListener('variantChanged', window.buyboxDiscountUpdate);
      document.removeEventListener('subscriptionToggleChanged', window.buyboxDiscountUpdate);
    }
    window.buyboxDiscountUpdate = updateDiscounts;
    document.addEventListener('variantChanged', updateDiscounts);
    document.addEventListener('subscriptionToggleChanged', updateDiscounts);
    updateDiscounts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyboxDiscounts);
  } else {
    initBuyboxDiscounts();
  }
  document.addEventListener('shopify:section:load', initBuyboxDiscounts);
  } catch(e) { console.error(e); }
})();

})();
